export const URL_BANNER_GET_LIST = `/banner/list`;
export const URL_BANNER_GET_DETAIL = `/banner/get`;
export const URL_BANNER_DELETE = `/banner/delete`;
export const URL_BANNER_CREATE = `/banner/submit`;

export const URL_BANNER_CLIENT_LIST = '/banner/list';
export const URL_BANNER_GET_POSITION = `common/dropdown-vitri-banner`;
export const URL_BANNER_CLIENT_LIST_V2 = '/banner/listv2';
export const URL_SLOGAN_CLIENT_LIST = '/banner/slogan';
